<template>
  <QuestionBase
      :question="question" :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
      :valid="!!data"
      :disabled-valid="false"
  >
    <InputBasic
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        :noSave="noSave"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'BuyToLetMonthlyRent',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: Number,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    propertyFound: {
      type: String,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    },
    question () {
      let title = 'How much monthly rent does the property command?'

      if (this.propertyFound === 'To Negotiate') {
        title = 'How much monthly rent does the property likely command?'
      }
      else if (this.propertyFound === 'Still Looking') {
        title = 'How much monthly rent would you like to command from the property?'
      }
      return  {
        title: title,
        subTitle: 'If you are unsure an estimate will suffice.',
        tip: null
      }
    }
  },
  data () {
    return {

      db: {
        saveLocation: 'mortgage_survey_save',
        saveField: 'rent',
        objectId: this.objectId
      },
      args: {
        placeholder: 'e.g. 750',
        label: null,
        type: 'number',
        skippable: false,
        required: true,
        inputClass: 'field-66',
        prependText: '£'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
